import React, { Component, ComponentType } from 'react';
import { compose } from 'redux';
import omit from 'lodash/omit';
import withTranslation from '@om-fe/core/core/i18n/with-translation';
import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
import Anchor, { AnchorPropsWithoutRoute } from '@om-fe/core/components/anchor/anchor';
import { RouteNames, ParamModel } from '@om-fe/core/core/routing/utils';
import { HomeTab } from '../match-content-tabs/match-content-tabs.constants';
import { CustomRouteNames } from '../../routes/routes';

type DisciplineAnchorProps = AnchorPropsWithoutRoute & I18nContextInterface;

class DisciplineAnchorComponent extends Component<DisciplineAnchorProps> {
    render() {
        const {
            children,
            isLarge,
            isLive,
            disciplineName,
            disciplineId,
            gettext,
        } = this.props;

        const anchorProps: AnchorPropsWithoutRoute = omit(
            this.props,
            [
                'children',
                'dispatch',
                'gettext',
                'disciplineId',
                'disciplineName',
                'childId',
                'childName',
                'disciplineRouteType',
                'isLive',
            ],
        );
        
        if (isLive) {
            return (
                <Anchor
                    {...anchorProps}
                    routeName={RouteNames.liveSports}
                    routeParams={{
                        liveDisciplineName: disciplineName.toLowerCase(),
                        liveDisciplineId: disciplineId,
                        liveLocationName: gettext('All'),
                        liveLocationId: 0
                    }}
                >
                    {children}
                </Anchor>
            );
        }

        if (isLarge) {

            return (
                <Anchor
                    {...anchorProps}
                    routeName={RouteNames.home}
                >
                    {children}
                </Anchor>
            );
        } else {

            const routeParams: ParamModel = {
                homeTab: HomeTab.AllSports,
            };

            return (
                <Anchor
                    {...anchorProps}
                    routeName={CustomRouteNames.home}
                    routeParams={routeParams}
                >
                    {children}
                </Anchor>
            );
        }
    }
}

const DisciplineAnchor: ComponentType<DisciplineAnchorProps> = compose<DisciplineAnchorProps>(
    withTranslation(),
)(DisciplineAnchorComponent);
export default DisciplineAnchor;
